import React from 'react';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { ReportEntityType } from '../../types/report.types';

interface Props {
  entityType: ReportEntityType;
  onChange: (entityType: ReportEntityType) => void;
}

function EntityTypeSelector({ entityType, onChange }: Props) {
  const options: { value: ReportEntityType; label: string }[] = [
    { value: 'Client', label: 'Clients' },
    { value: 'Plate', label: 'Plates' },
    { value: 'Ticket', label: 'Tickets' }
  ];

  return (
    <div className="mb-3">
      <label className="form-label me-3">
        <strong>Entity Type:</strong>
      </label>
      <ButtonGroup>
        {options.map((option) => (
          <ToggleButton
            key={option.value}
            id={`entity-type-${option.value}`}
            type="radio"
            variant={entityType === option.value ? 'primary' : 'outline-primary'}
            name="entityType"
            value={option.value}
            checked={entityType === option.value}
            onChange={() => onChange(option.value)}>
            {option.label}
          </ToggleButton>
        ))}
      </ButtonGroup>
    </div>
  );
}

export default EntityTypeSelector;
